import { render } from "./ProposalOpinionsOfOthers.vue?vue&type=template&id=77e090e4&scoped=true"
import script from "./ProposalOpinionsOfOthers.vue?vue&type=script&lang=js"
export * from "./ProposalOpinionsOfOthers.vue?vue&type=script&lang=js"

import "./ProposalOpinionsOfOthers.vue?vue&type=style&index=0&id=77e090e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e090e4"]])

export default __exports__